import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white py-3 px-6 text-center text-xs text-gray-500 dark:border-gray-800 dark:bg-gray-900">
      <div className="flex items-center justify-between">
        <span>v1.0.0 &copy; 2026 Autochek Africa</span>
      </div>
    </footer>
  );
};
export default Footer;
